




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'bc-blocking-overlay',
  components: {},
})
export default class BlockingOverlay extends Vue {}
